export const validateRemarks = (remarks) => {
    const regex = /^[^{}[\]<>*]*$/; 
    return regex.test(remarks);
  };